import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-change-game',
  templateUrl: './change-game.component.html',
  styleUrl: './change-game.component.scss'
})
export class ChangeGameComponent {

  public view: any = {}

  constructor( protected _tfmService : TFMService) { 
    
   }

   protected loadGameDetails(): Promise<void> {
    return this._tfmService.getSite().then(res => {
      
      this.view.site = res;
      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });
   }

  
}
